import React from 'react'

function NotFoundPage() {
    return (
        <div className="container product-section">
            <div className="shop-section">
                Page not found...
            </div>
        </div>
    )
}

export default NotFoundPage